<ion-grid
  class="invoices-credits-tables"
  [ngClass]="{
    'portrait-invoices-credit-tables': this.browserDimensions?.isPortrait,
    'no-credits-or-invoices-tables':
      !recentCredits.length && !recentInvoices.length,
  }"
>
  <h4
    *ngIf="recentCredits.length || recentInvoices.length"
    data-cy="recent-invoices-credits-title"
  >
    {{ translatorText.title }}
  </h4>

  <div *ngIf="isLoadingCredits" class="loading-spinner">
    <ion-spinner></ion-spinner>
  </div>
  <div
    *ngIf="
      recentCredits.length || (!recentCredits.length && recentInvoices.length)
    "
    class="invoices-credits-table-section"
  >
    <h5
      *ngIf="
        recentCredits.length || (!recentCredits.length && recentInvoices.length)
      "
      data-cy="recent-credits-title"
    >
      {{ translatorText.credits }}
    </h5>

    <div *ngIf="!isLoadingCredits">
      <div *ngIf="recentCredits.length">
        <ion-row class="table-header">
          <ion-col
            [size]="this.columnSizes[ColumnNames.CustomerInformation]"
            class="customer-column"
            data-cy="customer-column-heading"
          >
            <p>
              {{
                this.browserDimensions?.isPortrait && isTouch
                  ? translatorText.customerCut
                  : translatorText.customer
              }}
            </p>
          </ion-col>
          <ion-col
            [size]="this.columnSizes[ColumnNames.TransactionInformation]"
            class="transaction-column"
            data-cy="transaction-column-heading"
          >
            <p>
              {{
                this.browserDimensions?.isPortrait && isTouch
                  ? translatorText.transactionCut
                  : translatorText.transaction
              }}
            </p>
          </ion-col>
          <ion-col
            data-cy="cust-po-column-heading"
            [size]="this.columnSizes[ColumnNames.PoNumber]"
          >
            <p>{{ translatorText.custPo }}</p>
          </ion-col>
          <ion-col
            *ngIf="showOrderNumber"
            [size]="this.columnSizes[ColumnNames.OrderNumber]"
            class="order-number-column"
            data-cy="order-number-column-heading"
          >
            <p>
              {{
                'i18n.payments.recentInvoicesCredits.orderNumber' | translate
              }}
            </p>
          </ion-col>
          <ion-col
            [size]="this.columnSizes[ColumnNames.IssueDate]"
            class="issue-date-column"
            data-cy="issue-date-column-heading"
          >
            <p>
              {{
                this.browserDimensions?.isPortrait && isTouch
                  ? translatorText.issueDateCut
                  : translatorText.issueDate
              }}
            </p>
          </ion-col>
          <ion-col
            [size]="this.columnSizes[ColumnNames.Amount]"
            class="amount-column"
            data-cy="amount-column-heading"
          >
            <p>
              {{
                this.browserDimensions?.isPortrait && isTouch
                  ? translatorText.amountCut
                  : translatorText.amount
              }}
            </p>
          </ion-col>
          <ion-col
            [size]="this.columnSizes[ColumnNames.AmountDue]"
            class="amount-due-column"
            data-cy="amount-due-column-heading"
          >
            <p>
              {{
                this.browserDimensions?.isPortrait && isTouch
                  ? translatorText.amountDueCut
                  : translatorText.amountDue
              }}
            </p>
          </ion-col>
          <ion-col
            [size]="this.columnSizes[ColumnNames.DueDate]"
            class="due-date-column"
            data-cy="due-date-column-heading"
          >
            <p>{{ translatorText.dueDate }}</p>
          </ion-col>
          <ion-col
            [size]="this.columnSizes[ColumnNames.Status]"
            class="status-column"
            data-cy="status-column-heading"
          >
            <p>
              {{
                this.browserDimensions?.isPortrait && isTouch
                  ? translatorText.statusCut
                  : translatorText.status
              }}
            </p>
          </ion-col>
          <ion-col size="1"> </ion-col>
        </ion-row>
        <app-transaction-row-desktop
          *ngFor="let credit of recentCredits"
          [vm]="credit"
          [browserDimensions]="browserDimensions"
          [isTouch]="false"
          [selectable]="false"
          [translatorText]="transactionRowText"
          [isPayable]="false"
          [canCancelPayment]="
            (cancelPaymentsService.canCancelPayment$() | async) &&
            credit.status === Status.PENDING
          "
          [showFullPO]="showFullPO"
          [columnSizes]="columnSizes"
          [showOrderNumber]="showOrderNumber"
          (poClickEmitter)="poNumberClicked()"
          (moreOptionsClickEmitter)="openMoreOptions($event)"
          (viewInvoiceClickEmitter)="viewInvoice($event)"
        ></app-transaction-row-desktop>
      </div>
      <div *ngIf="!recentCredits.length && recentInvoices.length">
        <h5 data-cy="no-recent-credits-message">
          {{ translatorText.noRecentActivity }}
        </h5>
      </div>
    </div>
  </div>
  <div
    *ngIf="
      recentInvoices.length || (!recentInvoices.length && recentCredits.length)
    "
    class="invoices-credits-table-section"
  >
    <h5
      *ngIf="
        recentInvoices.length ||
        (!recentInvoices.length && recentCredits.length)
      "
      data-cy="recent-invoices-title"
    >
      {{ translatorText.invoices }}
    </h5>
    <div *ngIf="isLoadingInvoices" class="loading-spinner">
      <ion-spinner></ion-spinner>
    </div>
    <div *ngIf="!isLoadingInvoices">
      <div *ngIf="recentInvoices.length">
        <ion-row class="table-header">
          <ion-col
            [size]="this.columnSizes[ColumnNames.CustomerInformation]"
            class="customer-column"
            data-cy="customer-column-heading"
          >
            <p>
              {{
                this.browserDimensions?.isPortrait && isTouch
                  ? translatorText.customerCut
                  : translatorText.customer
              }}
            </p>
          </ion-col>
          <ion-col
            [size]="this.columnSizes[ColumnNames.TransactionInformation]"
            class="invoice-column"
            data-cy="transaction-column-heading"
          >
            <p>
              {{
                this.browserDimensions?.isPortrait && isTouch
                  ? translatorText.transactionCut
                  : translatorText.transaction
              }}
            </p>
          </ion-col>
          <ion-col
            data-cy="cust-po-column-heading"
            [size]="this.columnSizes[ColumnNames.PoNumber]"
          >
            <p>{{ translatorText.custPo }}</p>
          </ion-col>
          <ion-col
            *ngIf="showOrderNumber"
            [size]="this.columnSizes[ColumnNames.OrderNumber]"
            class="order-number-column"
            data-cy="order-number-column-heading"
          >
            <p>
              {{
                'i18n.payments.recentInvoicesCredits.orderNumber' | translate
              }}
            </p>
          </ion-col>
          <ion-col
            [size]="this.columnSizes[ColumnNames.IssueDate]"
            data-cy="issue-date-column-heading"
          >
            <p>
              {{
                this.browserDimensions?.isPortrait && isTouch
                  ? translatorText.issueDateCut
                  : translatorText.issueDate
              }}
            </p>
          </ion-col>
          <ion-col
            [size]="this.columnSizes[ColumnNames.Amount]"
            class="amount-column"
            data-cy="amount-column-heading"
          >
            <p>
              {{
                this.browserDimensions?.isPortrait && isTouch
                  ? translatorText.amountCut
                  : translatorText.amount
              }}
            </p>
          </ion-col>
          <ion-col
            [size]="this.columnSizes[ColumnNames.AmountDue]"
            class="amount-due-column"
            data-cy="amount-due-column-heading"
          >
            <p>
              {{
                this.browserDimensions?.isPortrait && isTouch
                  ? translatorText.amountDueCut
                  : translatorText.amountDue
              }}
            </p>
          </ion-col>
          <ion-col
            [size]="this.columnSizes[ColumnNames.DueDate]"
            class="due-date-column"
            data-cy="due-date-column-heading"
          >
            <p>{{ translatorText.dueDate }}</p>
          </ion-col>
          <ion-col
            [size]="this.columnSizes[ColumnNames.Status]"
            class="status-column"
            data-cy="status-column-heading"
          >
            <p>
              {{
                this.browserDimensions?.isPortrait && isTouch
                  ? translatorText.statusCut
                  : translatorText.status
              }}
            </p>
          </ion-col>
          <ion-col size="1"> </ion-col>
        </ion-row>
        <app-transaction-row-desktop
          *ngFor="let invoice of recentInvoices"
          [vm]="invoice"
          [browserDimensions]="browserDimensions"
          [isTouch]="false"
          [selectable]="false"
          [translatorText]="transactionRowText"
          [isPayable]="paymentsEnabled"
          [canCancelPayment]="
            (cancelPaymentsService.canCancelPayment$() | async) &&
            invoice.status === Status.PENDING
          "
          [showFullPO]="showFullPO"
          [columnSizes]="columnSizes"
          [showOrderNumber]="showOrderNumber"
          (poClickEmitter)="poNumberClicked()"
          (moreOptionsClickEmitter)="openMoreOptions($event)"
          (viewInvoiceClickEmitter)="viewInvoice($event)"
          (payInvoiceClickEmitter)="payInvoice($event)"
        ></app-transaction-row-desktop>
      </div>
      <div *ngIf="!recentInvoices.length && recentCredits.length">
        <h5>{{ translatorText.noRecentActivity }}</h5>
      </div>
    </div>
  </div>
</ion-grid>

<ion-grid
  *ngIf="!isLoadingCredits && !recentCredits.length && !recentInvoices.length"
>
  <app-empty-states [title]="translatorText.noRecentActivity">
  </app-empty-states>
</ion-grid>
